import CityPageTemplate from "../city-template/CityPageTemplate";
import { springfieldMoConfig } from "./data";

export default function SpringfieldMoPage() {
  return <CityPageTemplate config={springfieldMoConfig} />;
}